import { ExpandIcon, Icon, ListItem } from '@optimus-web/core';

export default (props: $TSFixMe) => {
    const { title, icon, opened, expandIcon, ...other } = props;

    return (
        <ListItem
            leftIcon={<Icon value={icon} />}
            rightIcon={expandIcon ? <ExpandIcon expanded={opened} /> : null}
            primaryText={title}
            data-test-icon-button={icon}
            {...other}
        />
    );
};
